import React, { useState, useEffect, Link } from "react";
import { useParams } from "react-router-dom";
import { add_money_orders, remove_money_orders, update_money_orders } from './actions';
import { useSelector, useDispatch } from 'react-redux';
import AdSense from 'react-adsense';
import Language_i18 from '../../js/useNationalLanguage.jsx';

function Ordergoogle() {
    const { slug_1 } = useParams();
    const { i18n, lang } = Language_i18();
    const money_orders = useSelector(state => state.money_orders);
    const amount_orders = useSelector(state => state.amount_orders);
    const discount_orders = useSelector(state => state.discount_orders);

    const translations = {
      en: {
        total: "Total",
        amountIncrease: "Amount increase",
        discount: "Discount",
        freeOffer: "Get 1 free offer for the next time"
      },
      vi: {
        total: "Tổng",
        amountIncrease: "Số lượng tăng",
        discount: "Chiết khấu",
        freeOffer: "Tặng 1 ưu đãi miễn phí cho lần tiếp theo"
      }
    };

    return (
        <>
            <div className="relative mt-0 p-2 rounded-md border-2 border-pink-500 bg-white">
                {money_orders ? (
                    <div className="text-xs lg:text-base">
                        🌟 {translations[lang]?.total || translations.en.total}: {money_orders} Coins
                    </div>) : (<></>)}
                <div className="text-xs lg:text-base">
                    🏷️ {translations[lang]?.amountIncrease || translations.en.amountIncrease}: {amount_orders}
                </div>
                <div className="text-xs lg:text-base">
                    🎁 {translations[lang]?.discount || translations.en.discount}: {discount_orders}%
                    <span className="ml-1">➔</span>
                    <span className="text-gray-600">
                        {translations[lang]?.freeOffer || translations.en.freeOffer}
                    </span>
                </div>
                <div className="absolute top-0 left-0 w-full h-full rounded-md border-2 border-pink-500 opacity-0 transition-opacity duration-300 hover:opacity-100"></div>
            </div>

            {slug_1 != 'orders_once' && (
                <div className="max-h-16">
                    <div className="cards">
                        <AdSense.Google
                            client="ca-pub-4574266110812955"
                            slot="1627514116"
                            style={{ display: 'block' }}
                            format='horizontal'
                            responsive='false'
                        />
                    </div>
                </div>
            )}
        </>
    );
}

export default Ordergoogle;
